import { Observable } from "./observable.js";
import { $theme } from "./store.js";

(window as any).bd = {
    Observable,
    $theme,
};
